export const appThemes = {
  swiftBlue: "swiftBlue"
};
